<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <!--全面体检-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a examin-card">

                    <!--标题-->
                    <div class="examin-icon">
                        <img src="@/assets/tijian-house.png">
                    </div>
                    <div class="examin-title">欢迎使用Sysale Robot 库存体检</div>
                    <div class="examin-subtitle">时刻了解您的库存健康状况</div>

                    <!--开始检测（结果）-->
                    <div class="examin-btn-box">
                        <div class="ebb-btn">
                            <div class="ebb-txt">
                                <i class="el-icon-check"></i><br>
                                <span>体检完成</span>
                            </div>
                        </div>
                        <div class="ebb-ball"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

        <!--体检记录-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--体检时间-->
                    <div class="examin-res-time">检测时间：{{checkDetail.checkTime}}</div>

                    <!--体检结果统计-->
                    <div class="examin-res-chart">
                        <span class="chart-name"> 已检测商品：<span class="chart-val">{{checkDetail.goodsNumber}}</span> </span>
                        <span class="chart-name"> 异常库存商品：<span class="chart-val" style="cursor:pointer" @click="forecastJump(1)">{{checkDetail.errorNumber}}</span> </span>
                        <span class="chart-name"> 临期商品：<span class="chart-val" style="cursor:pointer" @click="forecastJump(2)">{{checkDetail.expirationNumber}}</span> </span>
                        <span class="chart-name"> 过期商品：<span class="chart-val" style="cursor:pointer" @click="forecastJump(3)">{{checkDetail.overdueNumber}}</span> </span>
                        <span class="chart-name"> 缺货商品：<span class="chart-val" style="cursor:pointer" @click="forecastJump(4)">{{checkDetail.lackNumber}}</span> </span>
                    </div>

                    <!--表格标题-->
                    <div class="mycard-title" style="margin-bottom: 20px">
                        体检结果
                    </div>

                    <!--表格-->
                    <el-table ref="r_mainTable" :data="main$data" v-loading="main$loading" class="exam-table" size="medium" :row-key="getRowKeys" align="center" header-align="center">
                        <el-table-column show-overflow-tooltip prop="goodsName" label="商品" width="220" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="barcode" label="条码货号" width="220" align="center" header-align="center"> </el-table-column>
                        <el-table-column show-overflow-tooltip prop="skuVname" label="规格" width="100" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="unitName" label="单位" width="100" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="currentStock" label="当前库存量" width="140" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="safeStock" label="预计剩余库存" width="140" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="dValue" label="差异值" align="center" header-align="center"> </el-table-column>
                        <el-table-column label="临期库存" align="center" header-align="center">
                            <template slot-scope="scope">
                                {{scope.row.errorList&&scope.row.errorList.length&&scope.row.type==',2,'?'有':'无'}}
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <div class="expand-table-wrapper" v-if="scope.row.type==',2,'||scope.row.type==',1,3,'">
                                    <table cellspacing="0" cellpadding="0" border="0">
                                        <thead>
                                            <tr class="asd">
                                                <th style="width: 220px">生产日期</th>
                                                <th style="width: 220px">剩余保质期</th>
                                                <th style="width: 220px">库存量</th>
                                                <th>库存占比</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item,item_idx) in scope.row.errorList" :key="item_idx" class="asd">
                                                <td>{{item.productDate}}</td>
                                                <td>{{item.surplusDays}}天</td>
                                                <td>{{item.stockNumber}}</td>
                                                <td>{{item.stockRatio}}%</td>
                                            </tr>
                                            <tr v-if="!scope.row.errorList || !scope.row.errorList.length">
                                                <td colspan="4" style="text-align: center">没有数据</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin: 14px">
                        <el-pagination style="float: right"
                                       background
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                        <div style="clear: both;"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            eid:null,
            checkDetail:{ },
            // 表格
            main$page_size: 10,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: [],
            main$expands: [],

            type:'', //预测跳转
        }
    },
    methods: {
        //预测跳转
        forecastJump(num){
          this.type=','+num+',';
          this.fetchData()
        },
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/stock/check/getCheckGoodsList'), {
                checkId: self.eid,
                page: self.main$curr_page,
                rows: self.main$page_size,
                type: self.type,
            },{xPostType:'form'}).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                    self.type='';
                    // 默认展开行
                    if(res.data.rows.length){
                        self.main$expands = [res.data.rows[0].id]
                    }
                }
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        getRowKeys: function (row) {
            return row.id;
        }
    },
    created: function(){
      let self = this;

      // check 检测id
      self.eid = self.$route.query.eid;
      if (!self.eid) {
        self.xTo('/inventory/examination')
        return
      }

      // 加载体检详情
      self.xFetch.post(self.xApi('/robot/stock/check/getCheckDetails'), {
        id: self.eid
      },{xPostType:'form'}).then(function (res) {
        if (res.data.code != '00') {
          self.xEui.msg_error(res.data.text)
          self.xTo('/inventory/examination')
          return
        }
        self.checkDetail = res.data.data||{};
      });

      // 加载表格数据
      self.fetchData();
    },
    // keep-alive事件
    activated: function () {
        let self = this;

        // check 检测id
        self.eid = self.$route.query.eid;
        if (!self.eid) {
            self.xTo('/inventory/examination')
            return
        }

        // 加载体检详情
        self.xFetch.post(self.xApi('/robot/stock/check/getCheckDetails'), {
            id: self.eid
        },{xPostType:'form'}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                self.xTo('/inventory/examination')
                return
            }
            self.checkDetail = res.data.data||{};
        });

        // 加载表格数据
        self.fetchData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mycard-title{ color: #29CF87 }
    .mycard-title .mycard-title-icon{ font-size: 18px;position: relative;top: -5px;color: #909399 }
    /*examin-card*/
    .examin-card{ background: #29CF87;text-align: center;padding-top: 20px}
    .examin-card .examin-icon{ }
    .examin-card .examin-icon img{ width: 80px }
    .examin-card .examin-title{ font-size: 30px;color: #fff;text-align: center;margin-top: 22px }
    .examin-card .examin-subtitle{ font-size: 18px;color: #fff ;text-align: center;margin-top: 22px;}
    /*examin-btn-box*/
    .examin-btn-box{
        width: 180px;
        height: 180px;
        display: inline-block;
        border: 1px solid #b8e986;
        border-radius: 50%;
        margin: 20px 0;
        position: relative;
    }
    .examin-btn-box .ebb-btn{
        margin: 25px;
        width: 126px;
        height: 126px;
        border: 2px solid #7ed321;
        border-radius: 50%;
        background: #fff;
        position: relative;
    }
    .examin-btn-box .ebb-btn .ebb-txt{color: #29cf87;font-size: 28px;line-height: 32px;padding-top: 20px}
    .examin-btn-box .ebb-btn .ebb-txt i{ font-size: 56px; }
    .examin-btn-box .ebb-btn .ebb-txt span{
        font-size: 18px;
        font-weight: 700;
        position: relative;
        top: -14px;
    }
    .examin-btn-box .ebb-ball{
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .examin-btn-box .ebb-ball:before{
        content: '';
        display: table;
        position: absolute;
        left: 50%;
        margin-left: -5px;
        top: -5px;
        height: 10px;
        width: 10px;
        background: #fff;
        border-radius: 50%;
    }
    /*体检结果*/
    .examin-res-time{ font-size: 14px;color: #303133; }
    .examin-res-chart{ padding: 5px 0 25px 0 }
    .examin-res-chart .chart-name{ font-size: 16px;color: #303133;margin-right: 70px }
    .examin-res-chart .chart-val{ font-size: 16px;color: #29CF87; font-weight: 700 }
    /*table*/
    .exam-table .expand-table-wrapper{ border: 1px solid #ebeef5;border-left: none;border-right: none;padding: 0px 50px; }
    .exam-table .expand-table-wrapper table { width: 100% }
    .exam-table .expand-table-wrapper table th{ border-bottom: 1px solid #ebeef5;  }
    .asd th{  text-align: center;  }
    .asd td{  text-align: center;  }
</style>
<style>
    /*table*/
    .exam-table .el-table__expanded-cell{ padding: 0 }
</style>



// WEBPACK FOOTER //
// src/views/inventory/examination-complete.vue